import React from 'react';
import { inject, observer } from 'mobx-react';
import unionBy from 'lodash/unionBy';
import { Field, renderMultiSelect, renderToggle } from "../../../../utils/formFieldHelper";
import Section from '../../../Section/Section';
import Form from '../../../Settings/Form/Form';
import { StoresEnum } from '../../../../stores';

const TrackingSettingsForm = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const { trackingSettings = {} } = channel;
  const { shouldSendSpecificEvents = {} } = trackingSettings;
  const { enabled = false, eventsList = [] } = shouldSendSpecificEvents;

  const eventsMap = {
    inventory_call_started: 'Inventory call started',
    ad_impression: 'Ad impression',
    ad_impression_failed: 'Ad impression failed',
  };

  const selectedList = eventsList.map(eventName => ({ label: eventsMap[eventName] || eventName, id: eventName, isSelected: true }));
  const allEvents = Object.keys(eventsMap).map(eventName => ({ label: eventsMap[eventName], id: eventName, isSelected: false }));

  const mappedEvents = unionBy([...selectedList, ...allEvents], 'id');

  const onEventListChange = list => {
    if (list) {
      const mergedLists = unionBy([...list, ...selectedList], 'id');
      const newSelectedItems = mergedLists.filter(item => item.isSelected || item.isSelected === undefined).map(item => item.id);

      updateChannel({
        ...channel,
        trackingSettings: {
          ...trackingSettings,
          shouldSendSpecificEvents: {
            ...shouldSendSpecificEvents,
            eventsList: newSelectedItems,
          },
        },
      });
    }
  };

  const renderFields = () => (
    <>
      <Field
        name="trackingSettings.shouldSendAllEvents"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly}
        label="Send all of the events"
        onChange={newValue => {
          updateChannel({
            ...channel,
            trackingSettings: {
              ...trackingSettings,
              shouldSendAllEvents: newValue,
            },
          });
        }}
      />
      <Field
        name="trackingSettings.dispatchEvents.enabled"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly}
        label="Dispatch 'picked_answer' event to client"
        onChange={newValue => {
          updateChannel({
            ...channel,
            trackingSettings: {
              ...trackingSettings,
              dispatchEvents: {
                enabled: newValue,
              },
            },
          });
        }}
      />
      <Field
        name="trackingSettings.shouldSendSpecificEvents.enabled"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly}
        label="Send specific events"
        onChange={newValue => {
          updateChannel({
            ...channel,
            trackingSettings: {
              ...trackingSettings,
              shouldSendSpecificEvents: {
                ...shouldSendSpecificEvents,
                enabled: newValue,
              },
            },
          });
        }}
      />
      <Field
        name="Events"
        component={renderMultiSelect(mappedEvents)}
        readOnly={readOnly || !enabled}
        placeholder="Events"
        label="Events"
        savedSelectedItems={selectedList.map(({ label }) => label)}
        onClose={onEventListChange}
      />
      <Field
        name="trackingSettings.activityLogging"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly}
        label="Enable activity logs"
        onChange={newValue => {
          updateChannel({
            ...channel,
            trackingSettings: {
              ...trackingSettings,
              activityLogging: newValue,
            },
          });
        }}
      />
    </>
  );

  return (
    <Section title="TRACKING">
      <Form
        initialValues={channel}
        fields={renderFields()}
        onSubmit={updateChannel}
        hideCancelButton
        hideApproveButton
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(TrackingSettingsForm));
